import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';

const LoadingState = ({ message = "Loading..." }) => {
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color="#3B82F6" style={styles.spinner} />
      <Text style={styles.mainText}>{message}</Text>
      <Text style={styles.subText}>Please wait while we fetch your data</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 48,
  },
  spinner: {
    marginBottom: 16,
  },
  mainText: {
    color: '#4B5563',
    fontSize: 18,
    fontWeight: '500',
  },
  subText: {
    color: '#9CA3AF',
    fontSize: 14,
    marginTop: 8,
  },
});

export default LoadingState; 